"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var OAuthWindow_1 = __importDefault(require("@CommonFrontend/OAuth/OAuthWindow"));
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var TokenManagement_1 = __importDefault(require("SettingsAngular/Integrations/TokenManagement/TokenManagement"));
var IntegrationApiService_1 = __importDefault(require("SettingsAngular/Integrations/IntegrationApiService"));
var Utils_1 = require("@CommonFrontendBackend/Account/Integrations/Utils");
var oauthEnablingUI = require("../OauthEnablingUI");
var ZohoIntegration = (function () {
    function ZohoIntegration(make, createUi, $q, $http, apiBaseUrl, account, modal, telemetry, notifyUser) {
        this.make = make;
        this.createUi = createUi;
        this.$q = $q;
        this.$http = $http;
        this.apiBaseUrl = apiBaseUrl;
        this.account = account;
        this.modal = modal;
        this.notifyUser = notifyUser;
        this.enable = this.enable.bind(this);
        this.apiBaseUrl = apiBaseUrl;
        this.q = $q;
        this.http = $http;
        var enableUi = make(oauthEnablingUI, { name: "Zoho" });
        this.enablingUi = enableUi.ui;
        this.additionalSettingsUi = (0, MountReactComponent_1.default)(createUi)(react_1.default.createElement(TokenManagement_1.default, {
            integration: Types_1.ProviderType.Zoho,
            apiService: new IntegrationApiService_1.default(apiBaseUrl),
            notifyUser: this.notifyUser,
            telemetry: telemetry,
        }));
        this.ui = createUi(require("SettingsAngular/Integrations/Zoho/Zoho.html"));
    }
    ZohoIntegration.prototype.enable = function () {
        return __awaiter(this, void 0, Promise, function () {
            var e_1;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 5]);
                        return [4, OAuthWindow_1.default.show("".concat(this.apiBaseUrl, "/integration/zohoIntegrationsPlatform/enable"))];
                    case 1:
                        _b.sent();
                        this.account.integrations.zohoIntegrationsPlatform.enabled = true;
                        return [3, 5];
                    case 2:
                        e_1 = _b.sent();
                        if (!(e_1.statusCode === 500 && ((_a = e_1.additionalInfo) === null || _a === void 0 ? void 0 : _a.errorCode) === ErrorCodes_1.ServerErrorCode.ExternalUserIDAlreadyLinked)) return [3, 4];
                        return [4, this.modal.showConfirmModal({
                                title: "Overwrite existing user?",
                                explainer: (0, Utils_1.getRelinkExternalUserConfirmationMessage)("Zoho CRM"),
                                confirmLabel: "Re-link and continue",
                                confirming: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, OAuthWindow_1.default.show("".concat(this.apiBaseUrl, "/integration/zohoIntegrationsPlatform/enable?overwriteExistingLinkWithExternalUser=true"))];
                                            case 1:
                                                _a.sent();
                                                this.account.integrations.zohoIntegrationsPlatform.enabled = true;
                                                return [2];
                                        }
                                    });
                                }); },
                            })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    ZohoIntegration.prototype.disable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.http.delete("".concat(this.apiBaseUrl, "/integration/zohoIntegrationsPlatform/disable"))];
                    case 1:
                        res = _a.sent();
                        this.account.integrations.zohoIntegrationsPlatform.enabled = false;
                        return [2, res];
                }
            });
        });
    };
    return ZohoIntegration;
}());
exports.default = ZohoIntegration;
